import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import { form1 } from "../Service/Api";
import { getHeader } from "../config";
const Alumni = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    class: "",
    school2: "",
    fromYear: "",
    toYear: "",
    email: "",
    profession1: "",
    subject: "",
    fatherName: "",
    location: "",
    phone: "",
    school: "",
    profession3: "",
    fromYear: "",
    subject: "",
    school1: "",
    designation: "",
    address1: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

// useEffect(() => {
//     const interval = setInterval(() => {
//       window.location.reload(true); // Reloads the page
//     }, 1 * 60 * 1000); // 30 minutes in milliseconds

//     return () => clearInterval(interval); // Cleanup on unmount
//   }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.address) newErrors.address = "Address is required.";
    if (!formData.class) newErrors.class = "Class is required.";
    if (!formData.school2) newErrors.class = "Last Class is required.";
    if (!formData.fromYear) newErrors.toYear = "Batch is required.";
    if (!formData.subject) newErrors.subject = "Class is required.";
    if (!formData.fatherName) newErrors.fatherName = "Name is required.";
    if (!formData.toYear) newErrors.toYear = "Batch is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!formData.profession1)
      newErrors.profession1 = "Profession is required.";
    if (!formData.location) newErrors.location = "Location is required.";
    if (!formData.phone) newErrors.phone = "Mobile is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const type = "XYZ";
    console.log("Submitting form with type:", type); // Debugging line

    try {
      const { header } = getHeader(); // Make sure this function returns the correct headers
      const response = await form1(formData, header, type);
      console.log("Form submitted successfully", response);
      setSuccessMessage("Your Form Submitted Successfully.");
      setFormData({
        name: "",
        address: "",
        class: "",
        toYear: "",
        email: "",
        profession1: "",
        location: "",
        phone: "",
        subject: "",
        fatherName: "",
        school: "",
        profession3: "",
        fromYear: "",
        subject: "",
        school1: "",
        designation: "",
        address1: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const generateAcademicYears = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= startYear; y--) {
      years.push(`${y - 1}-${y}`);
    }
    return years;
  };

  return (
    <>
      <Header />
      <Breadcrumb
        pageTitle="Alumni Registration Form"
        mid="Alumni Registration Form"
        breadcrumbName="Alumni Registration Form"
      />
      <div className="inner-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="col-md-12">
                <h3 className="sub-title">Alumni Registration Form</h3>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="mainform">
                  <h4 className="mb-4">
                    Kindly select batch and class you joined in St. Thomas
                    School.
                  </h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Batch <span>*</span>
                        </label>
                        <select
                          className="form-control"
                          name="fromYear"
                          value={formData.fromYear}
                          onChange={handleChange}>
                          <option value="">- Select -</option>
                          {generateAcademicYears(1970).map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      {errors.fromYear && (
                        <div className="error">{errors.fromYear}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Class Joined <span>*</span>
                        </label>
                        <select
                          className="form-control"
                          name="class"
                          value={formData.class}
                          onChange={handleChange}>
                          <option value="">- Select -</option>
                          <option value="nur">Nursery</option>
                          <option value="lkg">LKG</option>
                          <option value="ukg">UKG</option>
                          <option value="1">I</option>
                          <option value="2">II</option>
                          <option value="3">III</option>
                          <option value="4">IV</option>
                          <option value="5">V</option>
                          <option value="6">VI</option>
                          <option value="7">VII</option>
                          <option value="8">VIII</option>
                          <option value="9">IX</option>
                          <option value="10">X</option>
                          <option value="11">XI</option>
                          <option value="12">XII</option>
                        </select>
                      </div>
                      {errors.class && (
                        <div className="error">{errors.class}</div>
                      )}
                    </div>
                  </div>

                  <h4 className="mb-4">
                    Kindly select batch and class you left from here.
                  </h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Batch <span>*</span>
                        </label>
                        <select
                          className="form-control"
                          name="toYear"
                          value={formData.toYear}
                          onChange={handleChange}>
                          <option value="">- Select -</option>
                          {generateAcademicYears(1970).map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      {errors.toYear && (
                        <div className="error">{errors.toYear}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Last Class <span>*</span>
                        </label>
                        <select
                          className="form-control"
                          name="school2"
                          value={formData.school2}
                          onChange={handleChange}>
                          <option value="">- Select -</option>

                          <option value="nur">Nursery</option>
                          <option value="lkg">LKG</option>
                          <option value="ukg">UKG</option>
                          <option value="1">I</option>
                          <option value="2">II</option>
                          <option value="3">III</option>
                          <option value="4">IV</option>
                          <option value="5">V</option>
                          <option value="6">VI</option>
                          <option value="7">VII</option>
                          <option value="8">VIII</option>
                          <option value="9">IX</option>
                          <option value="10">X</option>
                          <option value="11">XI</option>
                          <option value="12">XII</option>
                        </select>
                      </div>
                      {errors.school2 && (
                        <div className="error">{errors.school2}</div>
                      )}
                    </div>
                  </div>
                  <h4 className="mb-4">
                    Kindly provide the details of your ward studied/studying
                    here.
                  </h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Name <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="fatherName"
                          value={formData.fatherName}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.fatherName && (
                        <div className="error">{errors.fatherName}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Class <span>*</span>
                        </label>
                        <select
                          className="form-control"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}>
                          <option value="">- Select -</option>
                          <option value="nur">Nursery</option>
                          <option value="lkg">LKG</option>
                          <option value="ukg">UKG</option>
                          <option value="1">I</option>
                          <option value="2">II</option>
                          <option value="3">III</option>
                          <option value="4">IV</option>
                          <option value="5">V</option>
                          <option value="6">VI</option>
                          <option value="7">VII</option>
                          <option value="8">VIII</option>
                          <option value="9">IX</option>
                          <option value="10">X</option>
                          <option value="11">XI</option>
                          <option value="12">XII</option>
                        </select>
                      </div>
                      {errors.subject && (
                        <div className="error">{errors.subject}</div>
                      )}
                    </div>
                  </div>
                  <h4 className="mb-4">Personal Details</h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Name <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.name && (
                        <div className="error">{errors.name}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Email <span>*</span>
                        </label>
                        <input
                          type="text"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.email && (
                        <div className="error">{errors.email}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Mobile <span>*</span>
                        </label>
                        <input
                          type="text"
                          name="phone"
                          className="form-control"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.phone && (
                        <div className="error">{errors.phone}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Location (City) <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.location && (
                        <div className="error">{errors.location}</div>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-label">
                          Permanent Address <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.address && (
                        <div className="error">{errors.address}</div>
                      )}
                    </div>
                  </div>
                  <h4 className="mb-4">Education Details</h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">College</label>
                        <input
                          type="text"
                          name="school"
                          className="form-control"
                          value={formData.school}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Degree</label>
                        <input
                          type="text"
                          name="profession3"
                          className="form-control"
                          value={formData.profession3}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Sem / Year </label>
                        <input
                          type="text"
                          name="fromYear"
                          className="form-control"
                          value={formData.fromYear}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Stream</label>
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <h4 className="mb-4">Employment Details</h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label"> Profession</label>
                        <select
                          className="form-control"
                          name="profession1"
                          value={formData.profession1}
                          onChange={handleChange}>
                          <option value="">-Select-</option>
                          <option value="1">Accounting</option>
                          <option value="2">Agriculture</option>
                          <option value="3">Architecture</option>
                          <option value="4">Aviation</option>
                          <option value="5">Banking</option>
                          <option value="6">Business Services</option>
                          <option value="7">Consulting</option>
                          <option value="8">Education</option>
                          <option value="9">Trading</option>
                          <option value="10">Manufacturing</option>
                          <option value="11">Import/ Export</option>
                          <option value="12">Retail</option>
                          <option value="13">Defense</option>
                          <option value="14">Engineering</option>
                          <option value="15">Entertainment</option>
                          <option value="16">Fashion</option>
                          <option value="17">Finance</option>
                          <option value="18">Home Maker</option>
                          <option value="19">Hospitality</option>
                          <option value="20">IT</option>
                          <option value="21">Law</option>
                          <option value="22">Media</option>
                          <option value="23">Medicine</option>
                          <option value="24">Politics</option>
                          <option value="25">Retired</option>
                          <option value="26">Scientist</option>
                          <option value="27">Service Govt. Pvt.</option>
                          <option value="28">Social Work</option>
                          <option value="29">Student</option>
                          <option value="30">Travel and Tourism</option>
                          <option value="31">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Organisation Name</label>
                        <input
                          type="text"
                          name="school1"
                          className="form-control"
                          value={formData.school1}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          className="form-control"
                          value={formData.designation}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Office Address</label>
                        <input
                          type="text"
                          name="address1"
                          className="form-control"
                          value={formData.address1}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <input type="submit" value="Submit" />
                <div class="row">
                  <div className="row primarydiv">
                    <div className="col-lg-12 col-md-12">
                      {successMessage && (
                        <div className="primary-alert">{successMessage}</div>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Alumni;
